var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Menu } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../../store';
import { updateInitiatePrivateChat, updateSelectedChatOption, } from '../../../../../store/slices/roomSettingsSlice';
import { updateIsActiveChatPanel } from '../../../../../store/slices/bottomIconsActivitySlice';
const PrivateChatMenuItem = ({ name, userId }) => {
    _react_refresh_temp_2();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const onClick = () => {
        dispatch(updateIsActiveChatPanel(true));
        dispatch(updateInitiatePrivateChat({
            name,
            userId,
        }));
        dispatch(updateSelectedChatOption(userId));
    };
    return (_jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("button", { className: "text-gray-900 dark:text-darkText group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs lg:text-sm transition ease-in hover:bg-primaryColor hover:text-white", onClick: () => onClick(), children: t('left-panel.menus.items.private-chat') })) }) }));
};
_react_refresh_temp_1 = PrivateChatMenuItem;
$RefreshReg$(_react_refresh_temp_1, "PrivateChatMenuItem");
_react_refresh_temp_2(PrivateChatMenuItem, "1ChlJvBB95AqLMPcKPpaMal6kAI=", false, () => [useAppDispatch, useTranslation]);
export default PrivateChatMenuItem;
